import { IconProps } from '@bechtel/gds';
import { HTMLAttributes } from 'react';

export interface StatBlockRowComponentProps {
  value: string;
  valueText: string;
  total: string;
  icon: IconProps['icon'];
  loading?: boolean;
}

export type StatBlockRowProps = StatBlockRowComponentProps & HTMLAttributes<HTMLDivElement>;
